<template>
  <div class="moblie">
    <!-- 头部 -->
    <top></top>
    <el-row class="exmain">
      <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
      <el-col :xs="4" :sm="4" :md="5" :lg="4" :xl="3">
        <div class="main-left">
          <p :class="[current==index?'active':'']" v-for="(item, index) in leftMenu" :key="index" @click="changeNav(index)">
            <span v-if="langSet == 'zh'">{{item.ch}}</span>
            <span v-if="langSet == 'en'">{{item.en}}</span>
          </p>
        </div>
      </el-col>
      <el-col :xs="18" :sm="18" :md="14" :lg="14" :xl="11">
        <div class="main-right">
          <exhibitor ref="child"></exhibitor>
        </div>
      </el-col>
      <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import exhibitor from "./components/exhibitor.vue";
export default {
  components: {
    top,
    bottom,
    exhibitor
  },
  name: "exhibition",
  data() {
    return {
      leftMenu:[
        {
          ch: '展区',
          en: 'Product Zone'
        },
        {
          ch: '展商',
          en: 'Exhibitors'
        },
      //   {
      //     ch: '产品',
      //     en: 'Products'
      // }
      ],
      current: 1,
      langSet: ''
    };
  },
  created() { 
  },
  mounted() {
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    //console.log(this.$refs.child)
    this.companyList = this.$refs.child.companyList;
  },
  methods: {
    changeNav(index){
        if(index == 0){
            this.$router.push({path: '/exhibition'});
        }else if(index == 2){
            this.$router.push({path: '/product'});
        }
    }
  }
};
</script>

<style lang="scss" scoped>
  @media only screen and (max-width: 767px){
    .moblie .exmain{padding-top: 0.35rem;}
    .exmain .main-left  p{font-size: 11px; }
    .exmain .main-right{padding-left: 0.2rem;box-sizing: border-box;}
  }
</style>